import { ButtonGroup, ToggleButton } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  Controller,
  UseControllerProps,
  useFormContext,
} from "react-hook-form";

import { DateTime } from "luxon";

import Input from "../../../../common/components/form/Input";
import SearchAddress from "../../../../common/components/form/SearchAddress";
import Switch from "../../../../common/components/form/Switch";
import Textarea from "../../../../common/components/form/Textarea";
import { IDwelling } from "../../../dwelling/reducers";

const ServiceOrderingKeysForm: React.FC<UseControllerProps> = ({ name }) => {
  const { control, watch, getValues } = useFormContext();
  const nameIsAgency = `${name}.isAgency`;
  const isAgency = watch(nameIsAgency, getValues(nameIsAgency) ?? true);
  const dwelling: IDwelling = watch("dwelling");

  return (
    <div className="serviceOrdering_keys">
      <div className="serviceOrdering-subtitle">Les clés</div>
      <div className="serviceOrdering-text">
        Indiquez les informations pour récupérer les clés
      </div>
      <Switch
        control={control}
        name={nameIsAgency}
        defaultValue={isAgency}
        label={`Les clés sont disponibles à l'agence ${
          dwelling?.agency.label || ""
        } ?`}
      />
      {!isAgency && (
        <>
          <div className="serviceOrdering_keys_layout-infos">
            <Input
              label="Société"
              name={`${name}.societyName`}
              defaultValue=""
              control={control}
              rules={{ required: "veuillez indiquer un nom de société" }}
            />
            <Input
              label="Numéro de téléphone"
              name={`${name}.societyPhone`}
              defaultValue=""
              control={control}
              rules={{ required: "veuillez indiquer un numéro de téléphone" }}
            />
            <Input
              label="Adresse Email"
              name={`${name}.societyEmail`}
              defaultValue=""
              control={control}
              rules={{ required: "veuillez indiquer un email" }}
            />
            <Input
              label="Nom du contact"
              name={`${name}.contactName`}
              defaultValue=""
              control={control}
              rules={{ required: "veuillez indiquer une adresse" }}
            />
          </div>
        </>
      )}
      <div className="serviceOrdering_keys_layout-infos">
        <div className="form-input" style={{ maxWidth: "300px" }}>
          <span className="form-input_label">
            Disponibilité des clés
            <span className="form-input_label-required">&nbsp;*</span>
          </span>
          <Controller
            control={control}
            name={`${name}.availabilityDate`}
            defaultValue={DateTime.fromJSDate(new Date()).toISO()}
            render={({ field, fieldState }) => {
              return (
                <div>
                  <DatePicker
                    className={`mb-2 w-100 ${
                      fieldState.error && "form-input_field-error"
                    } form-input_field date-select`}
                    dateFormat="dd/MM/yyyy"
                    locale="fr"
                    onChange={(date) =>
                      field.onChange(DateTime.fromJSDate(date).toISO())
                    }
                    selected={field.value ? new Date(field.value) : undefined}
                  />
                  {fieldState?.error && (
                    <span className="form-input_error-message">
                      {fieldState.error?.message}
                    </span>
                  )}
                </div>
              );
            }}
            rules={{
              required: "Veuillez renseigner une date de disponibilité",
            }}
          />
          <Controller
            control={control}
            name={`${name}.isMorningSchedule`}
            defaultValue={false}
            render={({ field: { onChange, value } }) => {
              return (
                <ButtonGroup>
                  <ToggleButton
                    type="checkbox"
                    variant="outline-primary"
                    checked={value === true}
                    onClick={() => onChange(true)}
                    value={value}
                  >
                    le matin
                  </ToggleButton>
                  <ToggleButton
                    type="checkbox"
                    variant="outline-primary"
                    checked={value === false}
                    onClick={() => onChange(false)}
                    value={value}
                  >
                    l'après-midi
                  </ToggleButton>
                </ButtonGroup>
              );
            }}
          />
        </div>
        {!isAgency && (
          <div className="d-flex flex-column">
            <SearchAddress
              control={control}
              name={`${name}.address`}
              rules={{ required: "veuillez indiquer une adresse" }}
              label="Adresse postale"
              isDisabled={false}
            />
          </div>
        )}
      </div>
      {!isAgency && (
        <Textarea
          label="Information complémentaires"
          name={`${name}.comment`}
          placeholder="Horaires de l’agence, disponibles à l’accueil..."
          control={control}
        />
      )}
    </div>
  );
};

export default ServiceOrderingKeysForm;
